import { render, staticRenderFns } from "./Asset3d.vue?vue&type=template&id=6d62f434"
import script from "./Asset3d.vue?vue&type=script&lang=js"
export * from "./Asset3d.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports